export const blockIconsSocialPeopleAlt = (
	<span className='material-symbols-outlined'>people_alt</span>
);
